import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { Snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import type { FetchLocationGeocodeResponse } from '@rover/types';
import { fullApiUrl } from '@rover/utilities/apiUrl';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const LOCATION_GEOCODE_URL: string = fullApiUrl('utilities/location-geocode/');

type GetArgs = {
  address: string | null | undefined;
  region?: string;
  guaranteePostalCode: boolean;
  placeId: string | null | undefined;
};

export const get = async ({
  address,
  region,
  guaranteePostalCode,
  placeId,
}: GetArgs): Promise<FetchLocationGeocodeResponse> => {
  const ai = getAxiosInstance();
  const params = new URLSearchParams();
  params.append('query', address || '');
  params.append('region', region || '');

  if (guaranteePostalCode) {
    // the backend keys on the existence not the value
    // of this query param
    params.append('guarantee_postal_code', '');
  }

  if (placeId) {
    params.append('place_id', placeId);
  }

  try {
    const { data } = await ai.get<Snakeify<FetchLocationGeocodeResponse>>(LOCATION_GEOCODE_URL, {
      params,
    });
    return camelize(data, true);
  } catch (e: any) {
    return DefaultAPIErrorHandler(e, 'There was an error while fetching location geocode results.');
  }
};

export default { get };
